function cleanupFields(discrepancyReport) {
    let discrepancyReportObj = { ...discrepancyReport };

    delete discrepancyReportObj['_showDetails'];
    delete discrepancyReportObj['adjustedTotal'];
    delete discrepancyReportObj['OriginalDiscrepancies'];
    delete discrepancyReportObj['Source'];
    delete discrepancyReportObj['Destination'];
    delete discrepancyReportObj['Asset Type'];
    delete discrepancyReportObj['Trucker'];
    delete discrepancyReportObj['Dispatched'];
    delete discrepancyReportObj['Received'];
    delete discrepancyReportObj['Discrepancies'];
    delete discrepancyReportObj['Date Deployed'];
    delete discrepancyReportObj['Date Received'];
    delete discrepancyReportObj['Status'];

    return discrepancyReportObj;
}

export const DiscrepancyReportUtil = {
    cleanupFields
};
